import { ChartDataPoint, DonutChart } from '@fluentui/react-charts';
import MetricsTile, {
    MetricsTileComponent,
} from '../core/MetricsTile/MetricsTile';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ReportingMetricsCounts } from '../../../../../../model/ReportingMetrics';
import { useAppDispatch, useSelector } from '../../../../../../store/hooks';
import { updateFilters } from '../../../../../../store/features/reportingDashboard/reportingDashboardSlice';
import { useTableChart } from '../core/TableChart/chartUtils';
import TableChart from '../core/TableChart/TableChart';

export interface ICategoriesChartTileProps {
    currentItems: ReportingMetricsCounts;
}

const Chart: React.FC<{
    items: ReportingMetricsCounts;
}> = ({ items }) => {
    const { t } = useTranslation();

    const dispatch = useAppDispatch();

    const { tableData, chartData } = useTableChart(
        items,
        useCallback(
            (sortedItems) =>
                sortedItems.map<ChartDataPoint>((x) => {
                    return {
                        data: x.value,
                        legend: x.label,
                        color: x.color,
                    };
                }),
            []
        )
    );

    return (
        <TableChart
            chart={
                <DonutChart
                    data={{ chartData }}
                    hideLabels={false}
                    showLabelsInPercent
                    hideLegend
                />
            }
            tableProps={{
                rows: tableData,
                keyLabel: t('ReportingDashboard_Category'),
                valueLabel: t('ReportingDashboard_ConversationCount'),
                onRowClick: (row) => {
                    if (row.key) {
                        dispatch(updateFilters({ category: row.key }));
                    }
                },
            }}
        />
    );
};

const CategoriesChartTile: MetricsTileComponent<ICategoriesChartTileProps> = ({
    currentItems,
    title,
    className,
}) => {
    const { category } = useSelector((x) => x.reportingDashboard.filters);

    const dispatch = useAppDispatch();

    return (
        <MetricsTile
            title={title}
            currentRangeItem={
                !!Object.keys(currentItems).length ? (
                    <Chart items={currentItems} />
                ) : undefined
            }
            hidePreviousRange
            filter={{
                value: category,
                clear: () => dispatch(updateFilters({ category: null })),
            }}
            className={className}
        />
    );
};

export default CategoriesChartTile;
